/**
 * @param {*} raw
 * @return {{customMetadata: Array, id: number, name: string, parentId: number, slug: string}}
 */
export const channelModel = (raw) => ({
  customMetadata: raw.customMetadata || [],
  id: raw.id === undefined ? -1 : +raw.id,
  name: raw.name || 'ChannelName',
  parentId: raw.parentId === undefined || raw.parentId === null ? -1 : +raw.parentId,
  slug: raw.slug || 'channel-slug',
  featuredVideosId: raw.featuredVideosId || [],
  startVideoId: raw.startVideoId || null,
});

/**
 * @typedef {{
 *   customMetadata: *[],
 *   id: number,
 *   name: string,
 *   parentId: number,
 *   slug: string,
 *   featuredVideosId: videoModel.type[],
 *   startVideoId: string,
 * }}
 */
channelModel.type = null;
